import { cn } from "@newxsystems/shared";
import { DaylightCardLink } from "../../../../modules/content/components/DaylightCardLink/DaylightCardLink";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightRichText } from "../../../../modules/content/components/DaylightRichText/DaylightRichText";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { ITextContentGridBlockProps } from "./TextContentGridBlock.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
const spans = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "lg:col-span-4",
} as const;
export const TextContentGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITextContentGridBlockProps) => {
  if (!items?.length) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-10">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div
          className={cn(
            "grid grid-cols-1 overflow-hidden border-y border-border sm:grid-cols-2",
            columns[columnCount || 3],
          )}
        >
          {items.map((item, index) => (
            <DaylightCardLink
              className={cn(
                "relative min-h-64 border-b border-border p-7 before:absolute before:left-7 before:top-8 before:h-1 before:w-10 before:bg-cobalt hover:bg-sky/35 md:p-9 md:before:left-9",
                spans[item.columnSpan || 1],
              )}
              key={index}
              link={item.cardLink}
            >
              <h3 className="mt-16 max-w-[18ch] font-daylight-display text-3xl font-semibold leading-tight text-foreground">
                {item.heading}
              </h3>
              {item.description ? (
                <DaylightRichText
                  className="mt-4 text-base text-basalt md:text-lg"
                  content={item.description}
                />
              ) : null}
            </DaylightCardLink>
          ))}
        </div>
      </div>
    </DaylightSection>
  );
};

TextContentGridBlock.displayName = "Block::TextContentGridBlock";
